<template>
  <div class="sub_activities_config">
    <div class="autocomplete">
      <span class="autocomplete">
        <select name="activities_config_ids[]" ref="autocomplete_sub_activities_configs"></select>
      </span>
    </div>

    <table class="table table-hover">
      <thead>
        <tr class="heading">
          <th>{{ i18nJS.ordine }}</th>
          <th>{{ i18nJS.elimina }}</th>
          <th>{{ i18nJS.activity_label }}</th>
          <th>{{ i18nJS.note }}</th>
          <th>{{ i18nJS.from }}</th>
          <th>{{ i18nJS.data_termine }}</th>
        </tr>
      </thead>
      <tbody class="js-sortable">
        <template v-for="subActivitiesRel in subActivitiesRels">
          <tr
            class="flusso"
            :key="subActivitiesRel.id"
            v-if="!subActivitiesRel._blank"
            :data-activity-relation="subActivitiesRel.sub_activities_config_id"
          >
            <td>
              <div style="display: none">
                <input
                  type="text"
                  :name="'activities_config[sub_activities_config_relations_attributes][][id]'"
                  :value="subActivitiesRel.id"
                />

                <input
                  type="text"
                  :name="'activities_config[sub_activities_config_relations_attributes][][priority]'"
                  :value="subActivitiesRel.priority"
                />

                <input
                  type="text"
                  :name="'activities_config[sub_activities_config_relations_attributes][][sub_activities_config_id]'"
                  :value="subActivitiesRel.sub_activities_config_id"
                />
              </div>
            </td>

            <td>
              <a :title="i18nJS.elimina" @click="() => removeSubActivity(subActivitiesRel)">
                <i class="fa-light fa-trash"></i>
              </a>
            </td>

            <td>
              <div class="item-name">
                <a :href="subActivitiesRelPath(subActivitiesRel)">{{ subActivitiesRel.name }}</a>
              </div>
            </td>

            <td>
              <textarea
                :name="'activities_config[sub_activities_config_relations_attributes][][note]'"
                v-model="subActivitiesRel.note"
                :placeholder="i18nJS.empty_note"
              ></textarea>
            </td>

            <td>
              <div class="span3">
                <input
                  class="date date_done input-small use-datepicker"
                  type="text"
                  :name="'activities_config[sub_activities_config_relations_attributes][][start_date]'"
                  :value="humanEndDate(subActivitiesRel.start_date)"
                />
              </div>
            </td>

            <td>
              <div class="span3">
                <input
                  class="date date_done input-small use-datepicker"
                  type="text"
                  :name="'activities_config[sub_activities_config_relations_attributes][][end_date]'"
                  :value="humanEndDate(subActivitiesRel.end_date)"
                />
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'sub-activities-config',
  data() {
    return {
      activityConfigId: null,
      subActivitiesRels: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    $(document).ready(() => {
      this.attivateAutocomplete();
      this.activateSortable();
      this.activityConfigId = $('#sub-activities-config').data('activity-config-id');
      this.subActivitiesRels = $('#sub-activities-config').data('sub-activities');
    });
  },
  watch: {
    subActivitiesRels() {
      this.$nextTick(function () {
        this.activateDatePicker();
        this.activateSortable();
      });
    },
  },
  methods: {
    humanEndDate(date) {
      if (date != null) {
        return moment.utc(date).format(i18nJS.time.formats.date_only);
      } else {
        return null;
      }
    },
    removeSubActivity(subActivitiesRel) {
      if (confirm('sei sicuro?')) {
        if (subActivitiesRel.id != null) {
          $.ajax({
            url: `/${window.locale}/sub_activities_config_relations/${subActivitiesRel.id}`,
            type: 'DELETE',
            success: (response) => {
              this.removeSubActivityFromUI(subActivitiesRel);
            },
            error: () => {
              alert('An error occured while deleting your sub activity');
            },
          });
        } else {
          this.removeSubActivityFromUI(subActivitiesRel);
        }
      }
    },
    removeSubActivityFromUI(subActivitiesRel) {
      this.subActivitiesRels = this.subActivitiesRels.filter((e) => e !== subActivitiesRel);
      this.subActivitiesRels.forEach((e, i) => (e.priority = i));
    },
    subActivitiesRelPath(subActivitiesRel) {
      return '/' + window.locale + '/activities_configs/' + subActivitiesRel.sub_activities_config_id + '/edit';
    },
    attivateAutocomplete() {
      const autocompleteEl = $(this.$refs['autocomplete_sub_activities_configs']);
      const self = this;
      autocompleteEl
        .select2({
          placeholder: i18nJS.select_placeholder,
          ajax: {
            url: `/${window.locale}/activities_configs/get_activities_configs`,
            dataType: 'json',
            data: (params) => {
              const excluded_ids = self.subActivitiesRels.map((e) => e.sub_activities_config_id);
              excluded_ids.push(self.activityConfigId);
              const query = {
                search: params.term,
                page: params.page || 1,
                exclude_sub_activities_config_ids: excluded_ids.join(','),
              };
              return query;
            },
            results: (data, page) => {
              return {
                results: data.results,
              };
            },
          },
        })
        .on('select2:select', (e) => {
          const subActivitiesConfig = {
            id: null,
            sub_activities_config_id: e.params.data.id,
            name: e.params.data.text,
            note: null,
            start_date: null,
            end_date: null,
            priority: this.subActivitiesRels.length,
          };
          $(e.target).val('').trigger('change');
          this.subActivitiesRels.push(subActivitiesConfig);
        });
    },
    activateDatePicker() {
      $('.use-datepicker').datepicker({ dateFormat: i18nJS.time.formats.datepicker_date });
      $('.use-datepicker').change(function () {
        const endDate = $(this).datepicker();
        if (endDate.val() && !moment(endDate.val(), i18nJS.time.formats.date_only, true).isValid()) {
          alert(i18nJS.sub_activities.error_end_date);
          endDate.datepicker('setDate', null);
        }
      });
    },
    activateSortable() {
      const self = this;
      $('.js-sortable').sortable({
        stop() {
          $('.sub_activities_config .flusso')
            .toArray()
            .forEach((e, i) => {
              const subActivitiesRel = self.subActivitiesRels.find(
                (subActivityRel) => subActivityRel.sub_activities_config_id == e.dataset.activityRelation,
              );
              subActivitiesRel.priority = i;
            });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
div.autocomplete {
  margin: 20px 0;
}

.editable-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.left-content {
  display: flex;

  .item-name {
    font-weight: 200;
    font-size: 18px;
    padding-left: 20px;
    width: 200px;
  }
  .item-note {
    padding-left: 20px;
    width: 200px;
    textarea {
      width: 100%;
    }
  }
}

.toolbar {
  display: flex;

  a {
    padding: 20px;
  }
}
</style>
